<template>
  <div class="progress-bar">
    <p>
      {{ progress }}
      <span style="top: 0">{{extra}}</span>
      <span style="bottom: 0">{{total}}</span>
    </p>
    <div class="bar">
      <div class="bar-progress" :style="fillProgress"></div>
      <div class="bar-indicator" :style="positionIndicator"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProgressBar",
  props: {
    progress: Number,
    total: Number,
    extra: String
  },
  computed: {
    fillProgress() {
      const filled = (this.progress / this.total) * 100;
      return `width: ${filled}%`;
    },
    positionIndicator() {
      const filled = (this.progress / this.total) * 100;
      return `left: ${filled}%`;
    }
  }
};
</script>
<style scoped>
.progress-bar {
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

p {
  font-size: 1em;
  transform: translateY(-15%);
  position: relative;
  width: 100%;
  text-align: center;
}

span {
  font-size: 0.5em;
  position: absolute;
  right: 0;
}

.bar {
  background: #37474f;
  background: var(--color-tertiary);
  width: 100%;
  height: 4rem;
  display: inline-block;
  position: relative;
  padding: 0;
  border-radius: 1rem;
}

.bar-progress {
  display: inline-block;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  background: #006064;
  transition: transform 1s;
  transform: scaleX(1);
  transform-origin: 0%;
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}

.bar-indicator {
  height: 140%;
  position: absolute;
  z-index: 10;
  background: #f0f0f0;
  width: 1.5rem;
  top: -20%;
  transition: left 1s;
  border-radius: 1rem;
}
</style>
